"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APFilterMenu = exports.HeaderItem = void 0;
var ChevronRight_1 = __importDefault(require("@material-ui/icons/ChevronRight"));
var CloseRounded_1 = __importDefault(require("@material-ui/icons/CloseRounded"));
var FilterListRounded_1 = __importDefault(require("@material-ui/icons/FilterListRounded"));
var react_1 = __importStar(require("react"));
var APFlex_1 = require("../../layout/APFlex");
var APFilterMulti_1 = require("./APFilterMulti");
var APFilterSingle_1 = require("./APFilterSingle");
var APFilterDate_1 = require("./APFilterDate");
var APFilterRange_1 = require("./APFilterRange");
var __1 = require("../..");
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Divider_1 = __importDefault(require("@material-ui/core/Divider"));
var Popover_1 = __importDefault(require("@material-ui/core/Popover"));
function HeaderItem(_a) {
    var text = _a.text, style = _a.style;
    return react_1.default.createElement("div", { style: __assign({ color: "#888", marginLeft: "11px", marginRight: "11px", fontWeight: 500, fontSize: "14px", letterSpacing: "0.25px", lineHeight: "33px" }, style) }, text);
}
exports.HeaderItem = HeaderItem;
function APFilterMenu(_a) {
    var options = _a.options, label = _a.label, icon = _a.icon, _b = _a.headerWidth, headerWidth = _b === void 0 ? 120 : _b;
    var _c = react_1.useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var _d = react_1.useState(options[0].title), selected = _d[0], setSelected = _d[1];
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var id = open ? 'simple-popover' : undefined;
    var isSelected = false;
    options.forEach(function (option) {
        switch (option.type) {
            case 'multi':
                isSelected = isSelected || option.initialValue.length !== 0;
                break;
            case 'single':
                isSelected = isSelected || option.initialValue !== option.options[0].value;
                break;
        }
    });
    return react_1.default.createElement("div", { style: { color: "#666" } },
        icon
            ? react_1.default.createElement(IconButton_1.default, { size: 'small', 
                // color={isSelected ? "primary" : 'inherit'}
                onClick: function (event) {
                    setAnchorEl(event.currentTarget);
                } }, icon)
            : react_1.default.createElement(Button_1.default, { color: isSelected ? "primary" : 'inherit', onClick: function (event) {
                    setAnchorEl(event.currentTarget);
                } },
                react_1.default.createElement("span", { style: {
                        height: "18px",
                        // color: "#666",
                        fontSize: "13px",
                        letterSpacing: "0.4px",
                        lineHeight: "18px",
                        marginRight: "6px"
                    } }, label),
                react_1.default.createElement(FilterListRounded_1.default /* htmlColor="#666" */, { fontSize: "small" })),
        react_1.default.createElement(Popover_1.default, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: { vertical: 'bottom', horizontal: 'right', }, transformOrigin: { vertical: 'top', horizontal: 'center', }, PaperProps: { style: { minWidth: "240px" } } },
            react_1.default.createElement(APFlex_1.APColumn, { crossAxisAlignment: "stretch", mainAxisSize: "max", style: { minWidth: 420 - 120 + headerWidth + "px", height: "500px" } },
                react_1.default.createElement(APFlex_1.APRow, null,
                    react_1.default.createElement(__1.APExpanded, null,
                        react_1.default.createElement(__1.APPadding, { padding: 12 },
                            react_1.default.createElement(__1.APText, { style: { fontSize: "17px", fontWeight: 500 } }, label))),
                    react_1.default.createElement(__1.APButton, { size: "small", variant: "text", color: "primary", style: { fontWeight: 400 }, onClick: function () {
                            options.forEach(function (option) {
                                switch (option.type) {
                                    case "single":
                                        option.onChange(option.options[0].value);
                                        break;
                                    case "multi":
                                        option.onChange([]);
                                        break;
                                    case "range":
                                        option.onChange({ min: option.totalRange.min, max: option.totalRange.max });
                                        break;
                                    case "dateRange":
                                        option.onChange({ from: undefined, to: undefined });
                                        break;
                                    case "amount":
                                        option.onChange({ min: 0, max: 0 });
                                        break;
                                }
                            });
                        } }, "RESET"),
                    react_1.default.createElement(IconButton_1.default, { onClick: function () { return handleClose(); } },
                        react_1.default.createElement(CloseRounded_1.default, { htmlColor: "#8f8f8f" }))),
                react_1.default.createElement(Divider_1.default, null),
                react_1.default.createElement(__1.APExpanded, null,
                    react_1.default.createElement(APFlex_1.APRow, { crossAxisAlignment: "stretch" },
                        react_1.default.createElement(__1.APScrollView, { style: { backgroundColor: "#EEE", width: headerWidth } },
                            react_1.default.createElement(APFlex_1.APColumn, { crossAxisAlignment: "stretch" }, options.map(function (option, index) {
                                var isTouched = false;
                                switch (option.type) {
                                    case "single":
                                        isTouched = option.initialValue != option.options[0].value;
                                        break;
                                    case "multi":
                                        isTouched = option.initialValue.length != 0;
                                        break;
                                    case "range":
                                        isTouched = (option.initialValue.min != option.totalRange.min || option.initialValue.max != option.totalRange.max);
                                        break;
                                    case "dateRange":
                                        isTouched = (option.initialValue.from != null) || (option.initialValue.to != null);
                                        break;
                                    case "amount":
                                        isTouched = (option.initialValue.min != null) || (option.initialValue.max != null);
                                        break;
                                }
                                return react_1.default.createElement(APFlex_1.APRow, { key: index, onClick: function () {
                                        setSelected(option.title);
                                    }, mainAxisSize: "max", style: { padding: "12px", backgroundColor: selected == option.title ? "#FFF" : undefined, color: selected == option.title ? undefined : "#666" } },
                                    isTouched && react_1.default.createElement("div", { style: { borderRadius: "8px", height: "6px", width: "6px", backgroundColor: "#39F", marginRight: "6px" } }),
                                    react_1.default.createElement(__1.APExpanded, null,
                                        react_1.default.createElement(__1.APText, null, option.title)),
                                    react_1.default.createElement(ChevronRight_1.default, null));
                            }))),
                        react_1.default.createElement(Divider_1.default, { orientation: "vertical" }),
                        react_1.default.createElement(__1.APExpanded, { flex: 2 },
                            react_1.default.createElement(__1.APScrollView, { style: { padding: "8px" } }, options
                                .filter(function (option) { return option.title == selected; })
                                .map(function (option, index) {
                                switch (option.type) {
                                    case 'multi':
                                        return react_1.default.createElement(APFilterMulti_1.APFilterMulti, { key: index, initialValue: option.initialValue, header: option.title, options: option.options, onChange: function (v) { return option.onChange(v); } });
                                    case 'single':
                                        return react_1.default.createElement(APFilterSingle_1.APFilterSingle, { key: index, initialValue: option.initialValue, header: option.title, options: option.options, onChange: function (v) { return option.onChange(v); } });
                                    case 'dateRange':
                                        return react_1.default.createElement(APFilterDate_1.APFilterDate, { key: index, initialValue: option.initialValue, header: option.title, onChange: function (v) { return option.onChange(v); }, clearable: option.clearable });
                                    case 'range':
                                        return react_1.default.createElement(APFilterRange_1.APFilterRange, { key: index, initialValue: option.initialValue, totalRange: option.totalRange, header: option.title, onChange: function (v) { return option.onChange(v); } });
                                    case 'amount':
                                        return react_1.default.createElement(__1.APFilterAmount, { key: index, initialValue: option.initialValue, header: option.title, onChange: function (v) { return option.onChange(v); } });
                                }
                            }))))))));
}
exports.APFilterMenu = APFilterMenu;
